<template>
    <q-btn @mouseover.native="activatorHover = true" @mouseout.native="activatorHover = false"
           stretch flat no-caps
           class="text-white text-weight-regular"
           :loading="cart.cartItems.length > 0 && syncCartPending"
           :to="cart.cartItems.length > 0 ? '' : dynamicMenuItems.cart.path">
        <q-icon :name="dynamicMenuItems.cart.icon"><q-badge color="red" floating v-if="cart.cartItems.length > 0">{{ cart.cartItems.length }}</q-badge></q-icon>
        <q-menu v-model="menu"
                content-class="no-border no-border-radius">
            <q-list @mouseover.native="menuHover = true" @mouseout.native="menuHover = false"
                    v-if="cart.cartItems.length > 0" padding separator style="min-width: 150px">

                <q-item v-for="item in cart.cartItems" :key="item.id">
                    <q-item-section class="q-pa-xs">
                        <q-item-label>{{ item.description }}</q-item-label>
                        <q-item-label caption>Quantity: {{ item.quantity }}</q-item-label>
                    </q-item-section>

                    <q-item-section side top class="q-pa-xs">
                        <q-item-label>{{ item.netTotal | currency }}</q-item-label>
                    </q-item-section>
                </q-item>
                <q-item>
                    <q-item-section class="q-pa-xs">
                        <q-item-label><q-btn :to="dynamicMenuItems.cart.path" label="Review Cart & Checkout" color="warning" class="full-width q-mt-xs" size="0.9em" v-close-popup /></q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-menu>
    </q-btn>
</template>

<script>
    import { debounce } from 'quasar'
    import { mapState } from 'vuex'
    import { dynamicMenuItems } from '@/plugins/menuItems'

    export default {
        name: 'cart-menu',
        props: {
            hover: Boolean,
            debounceTime: {
                type: Number,
                default: 50,
            },
        },
        data() {
            return {
                menu: false,
                activatorHover: false,
                menuHover: false,
                debounceMenu: null,
                dynamicMenuItems: dynamicMenuItems
            }
        },
        methods: {
            checkMenu() {
                if (this.hover)
                    this.menu = this.activatorHover || this.menuHover
            },
        },
        computed: {
            ...mapState([
                'syncCartPending',
                'syncCartData',
            ]),
            showReinstatementCostDialog() { return this.$store.getters.showReinstatementCostDialog },
            cartItemAdded() { return this.$store.getters.cartItemAdded },
            cart() { return this.$store.getters.cart },
        },
        watch: {
            cartItemAdded(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        if (this.$route.path !== '/store/cart' && !this.showReinstatementCostDialog) {
                            this.menu = true
                        }
                    })
                }
            },
            menuHover() {
                this.debounceMenu()
            },
            activatorHover() {
                this.debounceMenu()
            },
        },
        created() {
            this.debounceMenu = debounce(this.checkMenu, this.debounceTime)
        },

    }
</script>
